import { Container } from "solid-bootstrap"
import { GoogleProfile } from "../googleprofile/googleprofile"
import { TCNavbar } from "../navbar/navbar"

export function AccountsRoute(props) {
    // Clear parameters from the URL when present.
    if (window.location.search) {
        window.history.replaceState({}, document.title, window.location.pathname);
    }
    return <>
    <TCNavbar />
        <Container class="d-flex flex-column gap-5 pt-3 pb-3">
        <h1>Manage your third party accounts</h1>
        <GoogleProfile />
    </Container>
    </>
}